import api from './api';

export interface Teacher {
  id: string;
  schoolId: string;
  userName: string;
  profileId?: string;
  firstName?: string;
  lastName?: string;
  enabled?: boolean;
  creationDatetime?: string;
  lastAuthenticationDatetime?: string;
}

export interface PageResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface TeacherSearchFilters {
  userName?: string;
  firstName?: string;
  lastName?: string;
  enabled?: boolean;
}

export interface TeacherSearchRequest {
  page?: number;
  size?: number;
  filters?: TeacherSearchFilters;
}

export const teacherService = {
  getAllTeachers: async (): Promise<Teacher[]> => {
    const response = await api.get<Teacher[]>('/{schoolId}/teachers');
    return response.data;
  },

  searchTeachers: async (request: TeacherSearchRequest = {}): Promise<PageResponse<Teacher>> => {
    const searchRequest = {
      page: request.page ?? 0,
      size: request.size ?? 100,
      filters: request.filters || {},
    };

    const response = await api.post<PageResponse<Teacher>>('/{schoolId}/teachers/search', searchRequest);
    return response.data;
  },

  getTeacherById: async (id: string): Promise<Teacher> => {
    const response = await api.get<Teacher>(`/{schoolId}/teachers/${id}`);
    return response.data;
  },

  createTeacher: async (teacher: Omit<Teacher, 'id' | 'schoolId' | 'creationDatetime' | 'lastAuthenticationDatetime'>): Promise<Teacher> => {
    const response = await api.post<Teacher>('/{schoolId}/teachers', teacher);
    return response.data;
  },

  updateTeacher: async (id: string, teacher: Omit<Teacher, 'id' | 'schoolId' | 'creationDatetime' | 'lastAuthenticationDatetime'>): Promise<Teacher> => {
    const response = await api.put<Teacher>(`/{schoolId}/teachers/${id}`, teacher);
    return response.data;
  },

  deleteTeacher: async (id: string): Promise<void> => {
    await api.delete(`/{schoolId}/teachers/${id}`);
  },

  resetPassword: async (id: string, newPassword: string): Promise<void> => {
    await api.post(`/{schoolId}/teachers/${id}/reset-password`, { newPassword });
  },
};

